import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigurationService } from '@sdbn/appclient';
import { Station } from 'src/tmc-yard/client/model/station';
import { TransportDetailsLayoutConverter } from 'src/tmc-yard/common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailLayout, TransportDetailMode } from 'src/tmc-yard/common/configuration/transport.configuration';
import { LayoutDefinition } from 'src/tmc-yard/components/transport-details/transport-details-model';

@Component({
  selector: 'app-sac-mobile-transport-details',
  templateUrl: './transport-details.component.html',
  styleUrls: ['./transport-details.component.scss']
})
export class MobileSacTransportDetailsComponent {

  TransportDetailMode = TransportDetailMode;

  @Input() station: Station;

  layoutDefinition: TransportDetailLayout;

  constructor(
    private configurationService: ConfigurationService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter
  ) {
    this.layoutDefinition = transportDetailsLayoutConverter.convert(this.readLayout());
  }

  private readLayout(): LayoutDefinition {
    // TODO eigenen Key für mobile Client bauen
    const propertyKey = 'ui-component.station-assignment.transport-details-grid.layout';
    const param = this.configurationService.getClientParam(propertyKey);

    if (param != null && param.value != null && param.value.length > 0) {
      try {
        const layout = new LayoutDefinition(JSON.parse(param.value));
        layout.dictionaryBase = 'dd.PROPERTY';
        layout.propertyId = param.id;
        return layout;
      } catch (error) {
        console.error('Error while reading layout form config [' + propertyKey + '].');
        return null;
      }
    }
  }

}
